import React from "react";

const CustomerDetails = ({ customerData }) => {
  const fields = [
    { label: "Name", value: customerData?.full_name, icon: "bi-person" },
    {
      label: "Mobile Number",
      value: customerData?.phoneNumber1,
      icon: "bi-telephone",
    },
    { label: "Email", value: customerData?.email, icon: "bi-envelope" },
    {
      label: "Father Name",
      value: customerData?.fatherName,
      icon: "bi-person-badge",
    },
    {
      label: "Gender",
      value: customerData?.gender,
      icon: "bi-gender-ambiguous",
    },
    {
      label: "Date Of Birth",
      value: customerData?.dob,
      icon: "bi-calendar-date",
    },
    {
      label: "Pan Number",
      value: customerData?.PanNumber,
      icon: "bi-card-heading",
    },
    {
      label: "Aadhar Number",
      value: customerData?.aadharNumber,
      icon: "bi-credit-card-2-front",
    },
    {
      label: "Customer Account Number",
      value: customerData?.loanAccountNumber,
      icon: "bi-bank",
    },
    {
      label: "Martial Status",
      value: customerData?.martialStatus,
      icon: "bi-heart",
    },
  ];

  // const address = [
  //   { label: "Address", value: parsedAddress.addressLine, icon: "" },
  //   { label: "City", value: parsedAddress.city, icon: "" },
  //   { label: "State", value: parsedAddress.state, icon: "" },
  //   { label: "Country", value: parsedAddress.country, icon: "" },
  //   { label: "Postal Code", value: parsedAddress.pincode, icon: "" },
  // ];

  // const currentAddress = [
  //   { label: "Address", value: parsedCurrentAddress.addressLine1, icon: "" },
  //   { label: "City", value: parsedCurrentAddress.city1, icon: "" },
  //   { label: "State", value: parsedCurrentAddress.state1, icon: "" },
  //   { label: "Country", value: parsedCurrentAddress.country1, icon: "" },
  //   { label: "Postal Code", value: parsedCurrentAddress.pincode1, icon: "" },
  // ];

  return (
    <div className="modal fade" id="show_details">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h3>Customer Document</h3>
            <button
              type="button"
              className="btn-close custom-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="card-body p-4 theme_new_color">
            <div className="row g-4">
              {fields.map((field, index) => (
                <div key={index} className="col-md-6">
                  <p className="info">
                    <span className="info-label">
                      <i className={`bi ${field.icon} me-2`}></i> {field.label}{" "}
                      :
                    </span>
                    <span className="info-value"> {field.value || "N/A"}</span>
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerDetails;
